import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { utilArray } from "../../utils/utilArray";
import { ResourceIcon } from "../generic/icon/ResourceIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
export var EventRewards = function (_a) {
    var rewards = _a.rewards, currentPoints = _a.currentPoints;
    var renderedRewards = rewards.map(function (reward, index) {
        var key = reward.id + "#" + index;
        var isRewardCompleted = getIsRewardCompleted(currentPoints, rewards, index);
        var isRewardSelected = getIsRewardSelected(currentPoints, rewards, index);
        var isRewardLocked = !isRewardCompleted && !isRewardSelected;
        var selectedClass = isRewardSelected ? IdStyles.StateSelected : "";
        return (React.createElement("div", { className: "event-reward", key: key },
            React.createElement(ResourceIcon, { styleId: IdStyles.IconExtraLarge, resource: reward, isLocked: isRewardLocked, isCompleted: isRewardCompleted }),
            React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: reward.amount }),
            React.createElement("div", { className: "event-reward__arrow " + selectedClass })));
    });
    return React.createElement("div", { className: "flex flex--spaced w100" }, renderedRewards);
};
var getIsRewardCompleted = function (currentPoints, rewards, index) {
    if (rewards[index] == undefined) {
        return false;
    }
    var currentThreshold = rewards[index].requiredThreshold;
    return currentPoints.greaterThanOrEqual(currentThreshold);
};
var getIsRewardSelected = function (currentPoints, rewards, index) {
    var isRewardCompleted = getIsRewardCompleted(currentPoints, rewards, index);
    if (index === 0) {
        return !isRewardCompleted;
    }
    var previousIndex = utilArray.adjustIndexToBoundaries(index - 1, rewards);
    var previousRewardCompleted = getIsRewardCompleted(currentPoints, rewards, previousIndex);
    var isLastThreshold = utilArray.isLastArrayIndex(index, rewards);
    return previousRewardCompleted && (!isRewardCompleted || isLastThreshold);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/EventRewards.tsx
// module id = 2777
// module chunks = 3